module.exports = __webpack_public_path__ + "img/profile-man-12-min.09e41c36.jpg";